/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangelogResponseDto
 */
export interface ChangelogResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ChangelogResponseDto
     */
    changelogId: string;
    /**
     * 
     * @type {string}
     * @memberof ChangelogResponseDto
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof ChangelogResponseDto
     */
    comment?: string;
    /**
     * 
     * @type {Date}
     * @memberof ChangelogResponseDto
     */
    logDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ChangelogResponseDto
     */
    type: ChangelogResponseDtoTypeEnum;
}


/**
 * @export
 */
export const ChangelogResponseDtoTypeEnum = {
    Created: 'CREATED',
    Updated: 'UPDATED'
} as const;
export type ChangelogResponseDtoTypeEnum = typeof ChangelogResponseDtoTypeEnum[keyof typeof ChangelogResponseDtoTypeEnum];


/**
 * Check if a given object implements the ChangelogResponseDto interface.
 */
export function instanceOfChangelogResponseDto(value: object): value is ChangelogResponseDto {
    if (!('changelogId' in value) || value['changelogId'] === undefined) return false;
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('logDate' in value) || value['logDate'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ChangelogResponseDtoFromJSON(json: any): ChangelogResponseDto {
    return ChangelogResponseDtoFromJSONTyped(json, false);
}

export function ChangelogResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangelogResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'changelogId': json['changelogId'],
        'entityId': json['entityId'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'logDate': (new Date(json['logDate'])),
        'type': json['type'],
    };
}

export function ChangelogResponseDtoToJSON(json: any): ChangelogResponseDto {
    return ChangelogResponseDtoToJSONTyped(json, false);
}

export function ChangelogResponseDtoToJSONTyped(value?: ChangelogResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'changelogId': value['changelogId'],
        'entityId': value['entityId'],
        'comment': value['comment'],
        'logDate': ((value['logDate']).toISOString()),
        'type': value['type'],
    };
}

